import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Image as ImageIcon, Pencil, Trash2, Globe, LayoutDashboard, X } from "lucide-react";

const API = "https://imarikafoundation.org/api/api/api/leadership";
// const API = "http://127.0.0.1:8080/api/api/leadership";


const LA_CSS = `
  .la-root { font-family:'Outfit',sans-serif; background:#f7f9fc; min-height:100vh; padding:2.5rem 1.25rem 5rem; }
  .la-shell { max-width:920px; margin:0 auto; }

  .la-topnav { display:flex; justify-content:center; gap:.75rem; margin-bottom:2.5rem; }
  .la-topbtn { display:inline-flex; align-items:center; gap:.5rem; padding:.6rem 1.25rem; border-radius:2px; font-size:.72rem; font-weight:800; letter-spacing:.08em; text-transform:uppercase; border:1px solid rgba(4,52,99,.15); background:#ffffff; color:#043463; cursor:pointer; transition:all .2s; text-decoration:none; }
  .la-topbtn:hover { border-color:#ee4c05; color:#ee4c05; transform:translateY(-1px); }
  .la-topbtn.primary { background:#043463; color:#fff; border-color:#043463; }
  .la-topbtn.primary:hover { background:#0e7fbb; border-color:#0e7fbb; color:#fff; }

  .la-h1 { font-family:'Bebas Neue',sans-serif; font-size:clamp(1.9rem,4vw,2.5rem); letter-spacing:.04em; color:#043463; text-align:center; margin-bottom:2rem; }
  .la-h1 span { color:#ee4c05; }

  .la-card { background:#ffffff; border:1px solid rgba(4,52,99,.1); border-radius:2px; box-shadow:0 4px 20px rgba(4,52,99,.04); }
  .la-form { padding:clamp(1.5rem,3vw,2.5rem); margin-bottom:3rem; }
  .la-form-h { font-family:'Bebas Neue',sans-serif; font-size:1.375rem; letter-spacing:.04em; color:#043463; margin-bottom:1.5rem; display:flex; align-items:center; gap:.6rem; }
  .la-form-h .dot { width:8px; height:8px; border-radius:100px; background:#ee4c05; }

  .la-field { margin-bottom:1.25rem; }
  .la-label { display:block; font-size:.65rem; font-weight:800; letter-spacing:.1em; text-transform:uppercase; color:#0e7fbb; margin-bottom:.5rem; }
  .la-input, .la-select, .la-textarea { width:100%; padding:.75rem 1rem; border:1px solid rgba(4,52,99,.15); border-radius:2px; font-family:'Outfit',sans-serif; font-size:.9rem; color:#043463; background:#fff; transition:border-color .2s; }
  .la-input:focus, .la-select:focus, .la-textarea:focus { outline:none; border-color:#ee4c05; }
  .la-textarea { min-height:110px; resize:vertical; }
  .la-row { display:grid; grid-template-columns:1fr 1fr; gap:1.25rem; }
  @media(max-width:600px){ .la-row { grid-template-columns:1fr; } }

  .la-dropzone { border:1.5px dashed rgba(4,52,99,.25); border-radius:2px; padding:1.25rem; text-align:center; cursor:pointer; transition:border-color .2s, background .2s; position:relative; background:#fbfcfe; }
  .la-dropzone:hover { border-color:#ee4c05; background:rgba(238,76,5,.03); }
  .la-dropzone input { position:absolute; inset:0; opacity:0; cursor:pointer; }
  .la-dropzone-icon { color:#0e7fbb; margin-bottom:.5rem; }
  .la-dropzone-text { font-size:.78rem; color:#4a5568; }
  .la-dropzone-text b { color:#043463; }

  .la-preview-wrap { position:relative; width:120px; }
  .la-preview-thumb { width:120px; height:120px; object-fit:cover; border-radius:100px; display:block; background:#f0f4f8; border:1px solid rgba(4,52,99,.1); }
  .la-preview-remove { position:absolute; top:-6px; right:-6px; width:24px; height:24px; border-radius:100px; background:rgba(4,52,99,.85); color:#fff; border:none; display:flex; align-items:center; justify-content:center; cursor:pointer; }
  .la-preview-remove:hover { background:#ee4c05; }
  .la-hint { font-size:.7rem; color:#4a5568; margin-top:.5rem; }

  .la-actions { display:flex; justify-content:flex-end; gap:.75rem; margin-top:1.75rem; }
  .la-btn { padding:.7rem 1.5rem; border-radius:2px; font-size:.72rem; font-weight:800; letter-spacing:.08em; text-transform:uppercase; border:none; cursor:pointer; transition:all .2s; }
  .la-btn-cancel { background:#eef1f5; color:#043463; }
  .la-btn-cancel:hover { background:#e2e8f0; }
  .la-btn-submit { background:#ee4c05; color:#fff; }
  .la-btn-submit:hover { background:#043463; }

  .la-list-h { font-family:'Bebas Neue',sans-serif; font-size:1.5rem; letter-spacing:.04em; color:#043463; text-align:center; margin-bottom:1.5rem; }

  .la-grid { display:grid; grid-template-columns:1fr; gap:1.1rem; }
  @media(min-width:640px){ .la-grid { grid-template-columns:repeat(2,1fr); } }

  .la-item { padding:1.1rem; display:flex; align-items:center; justify-content:space-between; gap:1rem; transition:border-color .2s; }
  .la-item:hover { border-color:rgba(238,76,5,.35); }
  .la-item-left { display:flex; align-items:center; gap:1rem; min-width:0; }
  .la-avatar { width:52px; height:52px; border-radius:100px; object-fit:cover; flex-shrink:0; border:1px solid rgba(4,52,99,.1); background:#f0f4f8; }
  .la-avatar-ph { width:52px; height:52px; border-radius:100px; background:#eef1f5; display:flex; align-items:center; justify-content:center; color:#0e7fbb; font-family:'Bebas Neue',sans-serif; font-size:1.2rem; flex-shrink:0; }
  .la-name { font-family:'Bebas Neue',sans-serif; font-size:1.05rem; letter-spacing:.03em; color:#043463; line-height:1.15; }
  .la-role { font-size:.78rem; color:#4a5568; margin-top:.15rem; }
  .la-role .cat { font-size:.62rem; color:#0e7fbb; text-transform:uppercase; letter-spacing:.08em; margin-left:.35rem; }

  .la-item-actions { display:flex; gap:.5rem; flex-shrink:0; }
  .la-mini-btn { display:inline-flex; align-items:center; gap:.3rem; padding:.4rem .7rem; border-radius:2px; font-size:.65rem; font-weight:800; letter-spacing:.05em; text-transform:uppercase; border:none; cursor:pointer; transition:all .2s; }
  .la-mini-edit { background:rgba(14,127,187,.1); color:#0e7fbb; }
  .la-mini-edit:hover { background:#0e7fbb; color:#fff; }
  .la-mini-del { background:rgba(238,76,5,.1); color:#ee4c05; }
  .la-mini-del:hover { background:#ee4c05; color:#fff; }

  .la-empty { text-align:center; padding:3.5rem 1rem; color:#4a5568; font-size:.875rem; }

  .la-toast { position:fixed; top:1.5rem; left:50%; transform:translateX(-50%); z-index:60; padding:.8rem 1.5rem; border-radius:2px; font-size:.8rem; font-weight:600; color:#fff; box-shadow:0 10px 30px rgba(4,52,99,.2); }
  .la-toast.success { background:#043463; }
  .la-toast.error { background:#ee4c05; }

  .la-loading { text-align:center; padding:5rem 1rem; color:#4a5568; font-family:'Outfit',sans-serif; font-size:.9rem; }
`;

const LeadershipAdmin = () => {
  // ================= STATE =================
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [feedback, setFeedback] = useState({ type: "", message: "" });
  const [imagePreview, setImagePreview] = useState(null); // blob URL or existing member.image URL
  const [fileInputKey, setFileInputKey] = useState(0);

  const [form, setForm] = useState({
    name: "",
    role: "",
    category: "board",
    bio: "",
    image: null,
  });

  const formRef = useRef(null);

  // ================= HELPER =================
  const showFeedback = (type, message) => {
    setFeedback({ type, message });
    setTimeout(() => {
      setFeedback({ type: "", message: "" });
    }, 3000);
  };

  // ================= FETCH =================
  const fetchMembers = async () => {
    try {
      const res = await axios.get(`${API}/`);
      setMembers(res.data.results || res.data);
    } catch (error) {
      console.error(error);
      showFeedback("error", "Failed to load members. Please check your connection.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  // Clean up blob preview URLs so we don't leak memory
  useEffect(() => {
    return () => {
      if (imagePreview && imagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  // ================= HANDLERS =================
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image" && files && files[0]) {
      setForm((prev) => ({ ...prev, image: files[0] }));
      setImagePreview(URL.createObjectURL(files[0]));
      return;
    }
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleRemoveImage = () => {
    setForm((prev) => ({ ...prev, image: null }));
    setImagePreview(null);
    setFileInputKey((k) => k + 1);
  };

  const resetForm = () => {
    setForm({
      name: "",
      role: "",
      category: "board",
      bio: "",
      image: null,
    });
    setImagePreview(null);
    setFileInputKey((k) => k + 1);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key]) {
        formData.append(key, form[key]);
      }
    });

    try {
      if (editingId) {
        await axios.patch(`${API}/${editingId}/`, formData);
        showFeedback("success", "Member updated successfully!");
      } else {
        await axios.post(`${API}/`, formData);
        showFeedback("success", "New member added successfully!");
      }

      resetForm();
      fetchMembers();
    } catch (err) {
      console.error(err.response?.data || err);
      showFeedback("error", "Failed to save member. Please check the inputs.");
    }
  };

  const handleEdit = (member) => {
    setForm({
      name: member.name,
      role: member.role,
      category: member.category,
      bio: member.bio,
      image: null, // no new file picked yet — keep showing existing image
    });

    setImagePreview(member.image ?? null);
    setFileInputKey((k) => k + 1);
    setEditingId(member.id);

    setTimeout(() => {
      formRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this member?")) return;

    try {
      await axios.delete(`${API}/${id}/`);
      showFeedback("success", "Member deleted successfully!");
      fetchMembers();
    } catch (error) {
      console.error(error);
      showFeedback("error", "Failed to delete member.");
    }
  };

  // ================= UI =================
  if (loading) {
    return (
      <div className="la-root">
        <style>{LA_CSS}</style>
        <p className="la-loading">Loading members…</p>
      </div>
    );
  }

  return (
    <div className="la-root">
      <style>{LA_CSS}</style>

      {feedback.message && (
        <div className={`la-toast ${feedback.type}`}>{feedback.message}</div>
      )}

      <div className="la-shell">
        {/* ===== NAVIGATION ===== */}
        <div className="la-topnav">
          <a href="/" className="la-topbtn">
            <Globe size={16} /> Website
          </a>
          <a href="/admin" className="la-topbtn primary">
            <LayoutDashboard size={16} /> Admin Home
          </a>
        </div>

        <h1 className="la-h1">Leadership <span>Management</span></h1>

        {/* ===== FORM ===== */}
        <form ref={formRef} onSubmit={handleSubmit} className="la-card la-form">
          <h3 className="la-form-h">
            <span className="dot" />
            {editingId ? "Edit Member" : "Add New Member"}
          </h3>

          <div className="la-field la-row">
            <div>
              <label className="la-label">Name</label>
              <input
                type="text"
                name="name"
                placeholder="Full name"
                required
                value={form.name}
                onChange={handleChange}
                className="la-input"
              />
            </div>
            <div>
              <label className="la-label">Role</label>
              <input
                type="text"
                name="role"
                placeholder="e.g. Executive Director"
                required
                value={form.role}
                onChange={handleChange}
                className="la-input"
              />
            </div>
          </div>

          <div className="la-field">
            <label className="la-label">Category</label>
            <select
              name="category"
              value={form.category}
              onChange={handleChange}
              className="la-select"
            >
              <option value="board">Board Member</option>
              <option value="staff">Staff Member</option>
            </select>
          </div>

          <div className="la-field">
            <label className="la-label">Bio</label>
            <textarea
              name="bio"
              placeholder="Short biography"
              value={form.bio}
              onChange={handleChange}
              className="la-textarea"
            />
          </div>

          <div className="la-field">
            <label className="la-label">Profile Image</label>
            {imagePreview ? (
              <div className="la-preview-wrap">
                <img src={imagePreview} alt="Preview" className="la-preview-thumb" />
                <button type="button" className="la-preview-remove" onClick={handleRemoveImage} aria-label="Remove image">
                  <X size={13} />
                </button>
              </div>
            ) : (
              <div className="la-dropzone" style={{ maxWidth: 320 }}>
                <input
                  key={fileInputKey}
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={handleChange}
                />
                <ImageIcon size={20} className="la-dropzone-icon" />
                <div className="la-dropzone-text"><b>Click to upload</b> a profile photo</div>
              </div>
            )}
            {editingId && !form.image && (
              <p className="la-hint">Leave empty to keep the current photo.</p>
            )}
          </div>

          <div className="la-actions">
            {editingId && (
              <button type="button" onClick={resetForm} className="la-btn la-btn-cancel">
                Cancel
              </button>
            )}
            <button type="submit" className="la-btn la-btn-submit">
              {editingId ? "Update Member" : "Add Member"}
            </button>
          </div>
        </form>

        {/* ===== MEMBERS LIST ===== */}
        <h3 className="la-list-h">All Members</h3>

        {members.length === 0 ? (
          <div className="la-card la-empty">No members yet — add your first one above.</div>
        ) : (
          <div className="la-grid">
            {members.map((member) => (
              <div key={member.id} className="la-card la-item">
                <div className="la-item-left">
                  {member.image ? (
                    <img src={member.image} alt={member.name} className="la-avatar" />
                  ) : (
                    <div className="la-avatar-ph">{member.name.charAt(0)}</div>
                  )}
                  <div style={{ minWidth: 0 }}>
                    <p className="la-name">{member.name}</p>
                    <p className="la-role">
                      {member.role}
                      <span className="cat">{member.category}</span>
                    </p>
                  </div>
                </div>

                <div className="la-item-actions">
                  <button onClick={() => handleEdit(member)} className="la-mini-btn la-mini-edit">
                    <Pencil size={12} /> Edit
                  </button>
                  <button onClick={() => handleDelete(member.id)} className="la-mini-btn la-mini-del">
                    <Trash2 size={12} /> Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadershipAdmin;